import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { CleanATC, EditATC, ModifyATC } from "../../../redux/actions";
import FormATC from "../FormATC";
import { PUT_ATC_CODE } from "../../../constants/codes";
import { Resource } from "ghost-stories/dist/unions/Resource";
import { FIX_URL } from "ghost-stories/dist/constants";

export const firstFile = (e) => e.target.files.item(0);

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const cod = "?code=" + PUT_ATC_CODE;
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const form = useSelector((state) => state.atc.form);

  const original = useSelector((state) =>
    state.atc.all.value.data.map((x) => x).find((xs) => xs.AtcID === id)
  );

  useEffect(() => {
    if (original === undefined) {
      return history.goBack();
    }
    dispatch(EditATC(original));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [original]);

  const onCancelar = useCallback(() => {
    dispatch(CleanATC({}));
    history.goBack();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const onChangeField = useCallback(
    (event) => {
      dispatch(
        EditATC({
          ...form,
          [event.target.name]: event.target.value,
        })
      );
    },
    [form, dispatch]
  );

  const onChageState = useCallback(
    (event) => {
      const valor = () => {
        if (event.target.checked === true) {
          return "S";
        }
        return "N";
      };
      dispatch(EditATC({ ...form, ATCState: valor() }));
    },
    [form, dispatch]
  );

  const onChangePhoto = useCallback(
    (event) => {
      var myHeaders = new Headers();
      myHeaders.append("type", "file");

      var formdata = new FormData();
      formdata.append("image", firstFile(event));

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        "https://az-fz-dbapi.azurewebsites.net/api/picture/upload?code=VZzIKS44D78LREowqJwxIGcqMARTo0S8at76Cot/1mE65fax/6aHnQ==",
        requestOptions
      ).then((response) => response.text());
      setTimeout(
        dispatch(
          EditATC({
            ...form,
            ATCPhotoURL:
              "https://fortaleza.blob.core.windows.net/pictures/" +
              event.target.files[0].name,
          })
        ),
        1000
      );
    },
    [dispatch, form]
  );

  const onSave = useCallback(
    (event) => {
      event.preventDefault();
      dispatch(ModifyATC(Resource.Query({ [FIX_URL]: id + cod, ...form })));
      history.goBack();
    },
    [dispatch, history, id, form, cod]
  );
  return (
    <FormATC
      {...{
        title: "Editar ATC",
        form,
        onCancelar,
        onChangeField,
        onChageState,
        onSave,
        onChangePhoto,
      }}
    />
  );
};
